export default {
	styleOverrides: {
		root: {
			padding: '8px',
			display: 'flex',
			flexDirection: 'column',
			gap: 0,
		},
	},
}
